// extracted by mini-css-extract-plugin
export default {"container":"RegionProd_container__kFEwf","linkItem":"RegionProd_linkItem__rx+rh"};